<template>
  <div class="card2">
    <div class="card2-img"
         :class="{'card2-img_right': leftEle === 'txt'}">
      <img @click.prevent
           :src="img"
           alt="">
    </div>
    <div class="card2-txts"
         :class="{'card2-txts_right': leftEle === 'txt'}">
      <h5>{{ title }}</h5>
      <p v-html="des"></p>
      <span class="card2-btn"
            @click="btnClick">{{ btnTxt }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    des: {
      type: String,
      default: ''
    },
    btnTxt: {
      type: String,
      default: '详情介绍'
    },
    leftEle: { // left element
      type: String,
      default: 'img' // 'txt' , 'img'
    }
  },
  data () {
    return {
    }
  },
  components: {},
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {
    btnClick () {
      this.$emit('toInfo')
    }
  }
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.card2 {
  padding: px2rem(20) px2rem(10);
  height: px2rem(200);
  position: relative;
  &-img {
    position: absolute;
    left: px2rem(10);
    top: px2rem(20);
    width: px2rem(240);
    height: px2rem(160);
    img {
      width: 100%;
    }
  }
  &-img_right {
    left: initial;
    right: px2rem(10);
  }
  &-btn {
    display: inline-block;
    text-align: center;
    border: px2rem(0.5) solid #3c3c3c;
    border-radius: 2px;
    font-size: px2rem(12);
    color: #3c3c3c;
    width: px2rem(80);
    line-height: px2rem(26);
  }
  &-txts {
    padding: px2rem(8) 0 0 px2rem(250);
    h5 {
      font-size: px2rem(15);
      line-height: px2rem(22);
      font-weight: bold;
    }
    p {
      padding: px2rem(8) 0;
      font-size: px2rem(12);
      color: #666666;
      text-align: left;
      min-height: px2rem(65);
    }
  }
  &-txts_right {
    padding: px2rem(8) px2rem(250) 0 0;
    text-align: right;
  }
}
</style>
